import React from 'react';
import type IssueTypeSettingsType from '@atlassian/jira-spa-apps-project-settings-issue-type/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyIssueTypeSettings = lazyForPaint<typeof IssueTypeSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-issue-type", jiraSpaEntry: "async-project-settings-issue-type" */ '@atlassian/jira-spa-apps-project-settings-issue-type'
		),
	),
);

type Props = RouteContext;

const AsyncIssueTypeSettings = ({ match }: Props): React.JSX.Element => {
	const { issueTypeId } = match.params;

	// unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
	const pageId = `project-settings-issue-types-${String(issueTypeId)}`;

	return <LazyPage Page={LazyIssueTypeSettings} pageId={pageId} shouldShowSpinner={false} />;
};

export default AsyncIssueTypeSettings;
